import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import { alpha } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import TextField from '@mui/material/TextField';
import TablePagination from '@mui/material/TablePagination';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useSelector, useDispatch } from 'react-redux';
import store from '../../store';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useRef, useState, useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import { useNavigate, Link, Location, useLocation } from 'react-router-dom';
import EditableText from '../common/EditableText';
import { Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import { Snackbar } from "@mui/material"
import NamedAutocomplete from '../common/NamedAutocomplete';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Drawer from '@mui/material/Drawer';
import { ArrowRight, Close, Download, Filter, Filter1, FilterAlt, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Fab } from '@mui/material';
import { ArrowLeftIcon, ArrowRightIcon } from '@mui/x-date-pickers';


function Row(props) {
  const dispatch = useDispatch();
  const { isChecker, row, onValueChange } = props;
  // const isItemSelected = isSelected(row.id);
  // const labelId = `enhanced-table-checkbox-${index}`;

  const handleItemSelectionChange = (event) => {
    row.isSelected = event.target.checked;
    if (event.target.checked) {
      dispatch({ type: 'addapprovedpayment', payload: event.target.value });
    }
    else {
      dispatch({ type: 'undoapprovedpayment', payload: event.target.value });
    }
    onValueChange(row);
  };

  const handleGrossAmountChange = (event) => {
    row.grossAmount = Number(event.target.value);
    row.netPayable = row.grossAmount - row.tds - row.advance - row.hold;
    onValueChange(row);
  };

  const handleTDSChange = (event) => {
    row.tds = Number(event.target.value);
    row.netPayable = row.grossAmount - row.tds - row.advance - row.hold;
    onValueChange(row);
  };

  const handleAdvanceChange = (event) => {
    row.advance = Number(event.target.value);
    row.netPayable = row.grossAmount - row.tds - row.advance - row.hold;
    onValueChange(row);
  };

  const handleHoldChange = (event) => {
    row.hold = Number(event.target.value);
    row.netPayable = row.grossAmount - row.tds - row.advance - row.hold;
    onValueChange(row);
  };

  const handleRemarksChange = (event) => {
    row.remarks = event.target.value;
    onValueChange(row);
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            onChange={handleItemSelectionChange}
            value={row.id}
            checked={row.isSelected}
          // inputProps={{
          //   'aria-labelledby': labelId,
          // }}
          />
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {row.id}
        </TableCell>
        <TableCell align="center">{row.vendor}</TableCell>
        <TableCell align="center">{row.invoiceNo}</TableCell>
        <TableCell align="center">{row.createdOn}</TableCell>
        <TableCell align="center">
          <EditableText
            initialValue={row.grossAmount}
            type="number"
            isEditable={isChecker}
            onValueChange={(event) => handleGrossAmountChange(event, row.id)}
          />
        </TableCell>
        <TableCell align="center">
          <EditableText
            initialValue={row.tds}
            type="number"
            isEditable={isChecker}
            onValueChange={(event) => handleTDSChange(event, row.id)}
          /></TableCell>
        <TableCell align="center">
          <EditableText
            initialValue={row.advance}
            type="number"
            isEditable={isChecker}
            onValueChange={(event) => handleAdvanceChange(event, row.id)}
          /></TableCell>
        <TableCell align="center">
          <EditableText
            initialValue={row.hold}
            type="number"
            isEditable={isChecker}
            onValueChange={(event) => handleHoldChange(event, row.id)}
          /></TableCell>
        <TableCell align="center">{row.netPayable}</TableCell>
        <TableCell align="center">
          <EditableText
            initialValue={row.remarks}
            type="text"
            isEditable={true}
            onValueChange={(event) => handleRemarksChange(event, row.id)}
          /></TableCell>
        <TableCell align="center">{row.location}</TableCell>
        <TableCell align="center">{row.user}</TableCell>
        <TableCell align="center">{row.checker}</TableCell>
        <TableCell align="center">{row.checkedOn}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  isChecker: PropTypes.bool.isRequired,
  row: PropTypes.shape({
    isSelected: PropTypes.bool,
    vendor: PropTypes.string.isRequired,
    grossAmount: PropTypes.number.isRequired,
    netPayable: PropTypes.number.isRequired,
    remarks: PropTypes.string.isRequired,
    user: PropTypes.string.isRequired,
    // issuedby: PropTypes.string.isRequired,
    // recievedby: PropTypes.string.isRequired,
  }).isRequired,
  onValueChange: PropTypes.func.isRequired,
};


//copied from sorting and selecting
function descendingComparator(a, b, orderBy) {
  if (b[orderBy]??"" < a[orderBy]??"") {
    return -1;
  }
  if (b[orderBy]??"" > a[orderBy]??"") {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  //console.log('In Stable sort');
  const stabilizedThis = Array.from(array).map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  //console.log('Out Stable sort');
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'id',
    numeric: true,
    disablePadding: false,
    label: 'ID',
  },
  {
    id: 'vendor',
    numeric: false,
    disablePadding: false,
    label: 'Vendor',
  },
  {
    id: 'invoiceNo',
    numeric: false,
    disablePadding: false,
    label: 'Invoice No',
  },
  {
    id: 'createdOn',
    numeric: false,
    disablePadding: false,
    label: 'Requested On',
  },
  {
    id: 'grossAmount',
    numeric: true,
    disablePadding: false,
    label: 'Gross Amount',
    editable: true,
  },
  {
    id: 'tds',
    numeric: true,
    disablePadding: false,
    label: 'TDS',
  },
  {
    id: 'advance',
    numeric: true,
    disablePadding: false,
    label: 'Advance',
  },
  {
    id: 'hold',
    numeric: true,
    disablePadding: false,
    label: 'Hold',
  },
  {
    id: 'netPayable',
    numeric: true,
    disablePadding: false,
    label: 'Net Payable',
  },
  {
    id: 'remarks',
    numeric: false,
    disablePadding: false,
    label: 'Remarks',
  },
  {
    id: 'location',
    numeric: false,
    disablePadding: false,
    label: 'Location',
  },
  {
    id: 'user',
    numeric: false,
    disablePadding: false,
    label: 'Maker',
  },
  {
    id: 'checker',
    numeric: false,
    disablePadding: false,
    label: 'Checker',
  },
  {
    id: 'checkedOn',
    numeric: false,
    disablePadding: false,
    label: 'Checked On',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className='info'>
        <TableCell />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align='center'
            //align={headCell.numeric ? 'right' : 'center'}
            //text-align='center'
            padding={headCell.disablePadding ? 'none' : 'normal'}
            //padding='none'
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'desc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function FilterDrawer(props) {
  const {setFilterSwitch} = props;
  const {locationList}= props;
  const {setLocation} = props;

  const {setReqSDate} = props;
  const {setReqEDate} = props;

  const {setCheSDate} = props;
  const {setCheEDate} = props;

  const [open, setOpen] = useState(false);

  const [vendor, setVendor] = useState('');

  const [reqStartDate, setReqStartDate] = useState(null);
  const [reqEndDate, setReqEndDate] = useState(null);

  const [checkStartDate, setCheckStartDate] = useState(null);
  const [checkEndDate, setCheckEndDate] = useState(null);

  const locationAutocompleteElement = useRef('');

  useEffect(()=>{
    setReqSDate(reqStartDate)
  },[reqStartDate])

  useEffect(()=>{
    setReqEDate(reqEndDate)
  },[reqEndDate])

  useEffect(()=>{
    setCheSDate(checkStartDate)
  },[checkStartDate])

  useEffect(()=>{
    setCheEDate(checkEndDate)
  },[checkEndDate])

  const handleFilter = (event) => {
    //console.log(`In handleFilter : ${event.target.value}`);
    //rows = rows.filter(row => row.department.includes(event.target.value));
    setVendor(event.target.value);
    setFilterSwitch(event.target.value);
    //console.log(`rows count : ${rows.length}`)              
  };

  const updateLocationSelection = (item) => {
    setLocation(item.name);
  };

  const clearFilter = () => {
    setVendor("");
    setFilterSwitch("");
    setReqStartDate(null);
    setReqEndDate(null);
    setCheckStartDate(null);
    setCheckEndDate(null);

    locationAutocompleteElement.current.resetState();

    setLocation("");

    setOpen(false);
  }

  {/* onClick={toggleDrawer(false)} */}
  const DrawerList = (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Box sx={{ width: 400, maxWidth: 'calc(100vw - 1.7rem)' }} p={2} role="presentation">

      <TextField value={vendor} style={{width: '100%' }} id="deptFilter" label="Vendor" variant="outlined" onChange={handleFilter} />
      
      <Typography
        edge="start"
        m={0.5}
        color="inherit"
        variant="subtitle1"
        component="div"
      >
        Requsted:
      </Typography>
      <div style={{display:'flex'}}>
      <DatePicker sx={{width: '100%'}} label="Start" format="DD/MM/YYYY" value={reqStartDate} onChange={setReqStartDate} />
      <DatePicker sx={{width: '100%'}} label="End" format="DD/MM/YYYY" value={reqEndDate} onChange={setReqEndDate} />
      </div>
      
      <Typography
        edge="start"
        m={0.5}
        color="inherit"
        variant="subtitle1"
        component="div"
      >
        Checked:
      </Typography>
      <div style={{display:'flex'}}>
      <DatePicker sx={{width: '100%'}} label="Start" format="DD/MM/YYYY" value={checkStartDate} onChange={setCheckStartDate} />
      <DatePicker sx={{width: '100%'}} label="End" format="DD/MM/YYYY" value={checkEndDate} onChange={setCheckEndDate} />
      </div>

      <Typography
        edge="start"
        m={0.5}
        color="inherit"
        variant="subtitle1"
        component="div"
      >
        Location:
      </Typography>
      <NamedAutocomplete suggestions={locationList} ref={locationAutocompleteElement} change={updateLocationSelection}/>
      <hr/>
      <Button style={{width:'100%'}} variant="outlined" onClick={clearFilter}>Clear Filter</Button>
    </Box>
    </LocalizationProvider>
  );

  return (
    <div>
      {/* <Button variant="contained" style={{justifyContent: 'flex-end'}} onClick={toggleDrawer(true)}>Filter</Button> */}
      <Drawer variant='persistent' anchor='right' open={open}>
          {DrawerList}
      </Drawer>
      <Fab style={{position: 'fixed',
        bottom: '2rem',
        right: open ? 'calc(min(400px, 100vw - 1.9rem) - 1.7rem)' : '2rem', // Adjust 240px to the width of the drawer
        transition: 'right 0.2s ease',
        zIndex: 1300,
      }} onClick={ ()=>{ setOpen(!open)}} color="primary" aria-label="close">
        { open ? <ArrowRightIcon /> : <FilterAlt />}
      </Fab>
    </div>
  );
}
FilterDrawer.prototype = {
  setFilterSwitch: PropTypes.func,
  locationList: PropTypes.array,
  setLocation: PropTypes.func,
  setReqSDate: PropTypes.func,
  setReqEDate: PropTypes.func,
  setCheSDate: PropTypes.func,
  setCheEDate: PropTypes.func,
};

function EnhancedTableToolbar(props) {
  const { grossAmount, tds, advance, hold, netPayable, onClear } = props;
  return (
    <Collapse in={grossAmount > 0} timeout="auto" unmountOnExit>
      <Toolbar
        sx={{
          ml: "auto",
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(grossAmount > 0 && {
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
          }),
        }}
      >

        {grossAmount > 0 ? (
          <div style={{
            width: "100vw",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            alignItems: "center",
          }}>
            <Typography
              color="inherit"
              variant="subtitle1"
              component="div"
              marginRight={3}
            >
              <b>Gross Total:&nbsp;</b> {grossAmount}
            </Typography>
            <Typography
              color="inherit"
              variant="subtitle1"
              component="div"
              marginRight={3}
            >
              <b>TDS:&nbsp;</b> {tds}
            </Typography>
            <Typography
              color="inherit"
              variant="subtitle1"
              component="div"
              marginRight={3}
            >
              <b>Advance:&nbsp;</b> {advance}
            </Typography>
            <Typography
              color="inherit"
              variant="subtitle1"
              component="div"
              marginRight={3}
            >
              <b>Hold:&nbsp;</b> {hold}
            </Typography>
            <Typography
              color="inherit"
              variant="subtitle1"
              component="div"
              marginRight={3}
            >
              <b>Net Payable:&nbsp;</b> {netPayable}
            </Typography>
            <IconButton style={{
              marginLeft:"auto",
              marginRight:"0.2rem",
            }} edge="end" aria-label="clear" float="right"
              onClick={() => {
                onClear();
              }}>
              <ClearIcon />
            </IconButton>
          </div>
        ) : (
          <></>
        )}

        {/* {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filter list">
            <IconButton>
              <FilterListIcon />
            </IconButton>            
          </Tooltip>
        )} */}
      </Toolbar>
    </Collapse>
  );
}

EnhancedTableToolbar.propTypes = {
  grossAmount: PropTypes.number.isRequired,
  tds: PropTypes.number.isRequired,
  advance: PropTypes.number.isRequired,
  hold: PropTypes.number.isRequired,
  netPayable: PropTypes.number.isRequired,
  onClear: PropTypes.func.isRequired,
};

//end copying from sorting and selecting

export default function CollapsibleTable() {

  //console.log('in collapsible table');
  const REQUEST_URL = "/PaymentApproval/GetPaymentRequestForApproval";
  const { auth, setAuth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  //let rows = [];

  const [snackMessage, setSnackMessage] = React.useState("");
  const [isSnack, setSnack] = React.useState(false);

  // need to fetch data from api
  const [rows, setPaymentRequestRows] = React.useState([]);

  //setting data in redux store
  const dispatch = useDispatch();

  // let rows = useSelector(() => store.getState().orderitem.ApprovalOrders);
  const approvedPaymentRequests = useSelector(() => store.getState().payment.approvedpayments);
  // console.log(`Rows key length : ${Object.keys(rows).length}`);

  const getPaymentRequests = () => {
    //console.log('start of get');
    try {
      //console.log(`Bearer ${auth.accessToken}`)
      const response = axiosPrivate.get(REQUEST_URL, {
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
          'Authorization': `Bearer ${auth?.accessToken}`
          //'access-control-allow-origin' : '*'
        }
      })
        .then(response => {
          //console.log(response.data);
          //console.log(`Response : ${JSON.stringify(response.data)}`);
          const data = response.data;
          data.map(item => item.isSelected = false);
          setPaymentRequestRows(data);
          //rows = response.data;
          // dispatch({ type: 'addOrders', payload: response.data  });
          //console.log(`Rows : ${[...rows]}`);
          setLocationList([{name:"Any"}, {name:"Changodar"}, {name:"Sanand"}, {name:"Ahmedabad"}]);
        })
        .catch(error => {
          console.log(error);
        });

    }
    catch (err) {

      console.log(err.response);

    }
  }

  useEffect(() => {

    // console.log(`Approval`)
    if (Object.keys(rows).length === 0) {
      getPaymentRequests();
    }

  }, []);




  //console.log([...rows]);

  //start copy from sorting and selecting

  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('id');
  const [filterSwitch, setFilterSwitch] = useState('');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paymentStatusList, setPaymentStatusList] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [location, setLocation] = useState("");

  const [reqStartDate, setReqStartDate] = useState(null);
  const [reqEndDate, setReqEndDate] = useState(null);
  const [checkStartDate, setCheckStartDate] = useState(null);
  const [checkEndDate, setCheckEndDate] = useState(null);
  const [authStartDate, setAuthStartDate] = useState(null);
  const [authEndDate, setAuthEndDate] = useState(null);
  const [rejStartDate, setRejStartDate] = useState(null);
  const [rejEndDate, setRejEndDate] = useState(null);


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    //console.log('setOrder');
    setOrder(isAsc ? 'desc' : 'asc');
    //console.log('setOrderby');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      //console.log('setSelected')
      setSelected(newSelected);
      return;
    }
    //console.log('setSelected empty')
    setSelected([]);
  };

  const handleFilter = (event) => {
    //console.log(`In handleFilter : ${event.target.value}`);
    //rows = rows.filter(row => row.department.includes(event.target.value));
    setFilterSwitch(event.target.value);
    //console.log(`rows count : ${rows.length}`)              
  };

  const handleChangePage = (event, newPage) => {
    //console.log('setpage');
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    //console.log('setRowsPerPage');
    setRowsPerPage(parseInt(event.target.value, 10));
    //console.log('setpage 1');
    setPage(0);
  };

  const handleChangeDense = (event) => {
    //console.log('setdense');
    setDense(event.target.checked);
  };

  const parseDate = (dateString) => {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    return new Date(year, month - 1, day);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const [filteredRow, visibleRows] = React.useMemo(
      () =>{
        //stableSort(rows, getComparator(order, orderBy))
        //console.log('inside memo');
        const locationIndex = locationList.findIndex(item => item.name == location)
  
        const filteredRows = rows.filter(row => {
          return (row.vendor.toLowerCase().includes(filterSwitch.toLowerCase()) 
          && (locationIndex < 1 ||
            row.location == location
          )
          && (reqStartDate==null || (row.createdOn !=null && parseDate(row.createdOn) >= reqStartDate)) 
          && (reqEndDate==null || (row.createdOn !=null && parseDate(row.createdOn) <= reqEndDate))
          && (checkStartDate==null || (row.checkedOn !=null && parseDate(row.checkedOn) >= checkStartDate)) 
          && (checkEndDate==null || (row.checkedOn !=null && parseDate(row.checkedOn) <= checkEndDate))
        )
        }).slice().sort(getComparator(order, orderBy));
  
        const start = Math.max(Math.min(page * rowsPerPage, filteredRows.length - 1), 0);
        const end = start + rowsPerPage;
  
        if(page > filteredRows.length/rowsPerPage)
          setPage(Math.round(filteredRows.length/rowsPerPage-1))
        if(page < 0)
          setPage(0)
  
        return [filteredRows, filteredRows.slice(
                  start,
                  end,
                )];
      },
      [rows,filterSwitch,order, orderBy, page, rowsPerPage, location, reqStartDate, reqEndDate, checkStartDate, checkEndDate],
    );

  const [approved, setApproved] = useState(0);

  useEffect(() => {
    if (approved > 0) {

      setSnackMessage(`${approved} payment has been approved/rejected!`);
      //recall the getPaymentRequests here
      getPaymentRequests();
      setApproved(0);
    }
  }, [approved]);

  //end copy from sorting and selecting

  const handleSubmit = async (e) => {
    //console.log(`handleSubmit rows : ${JSON.stringify(rows)}`);
    //console.log(`handleSubmit approvedPaymentRequests : ${JSON.stringify(approvedPaymentRequests)}`);

    const REQUEST_URL_APPROVAL = "/PaymentApproval/ApprovePaymentRequests";
    const REQUEST_URL_REJECTION = "/PaymentApproval/RejectPaymentRequests";

    let approvedPaymentRequestsForSubmission = [];

    approvedPaymentRequests.forEach((approvedPaymentRequest) => {
      approvedPaymentRequestsForSubmission.push(rows.find((row) => row.id == approvedPaymentRequest));
      setPaymentRequestRows(rows.filter(row => row.id != approvedPaymentRequest));
      //console.log('rows updated');

    });

    let url = ""
    if(e.target.className.includes('btn-success')){
      url = REQUEST_URL_APPROVAL;
    } else {
      url = REQUEST_URL_REJECTION;
    }

    const approvedCount = approvedPaymentRequestsForSubmission.length;

    //console.log(`handleSubmit approvedPaymentRequestsForSubmission : ${JSON.stringify(approvedPaymentRequestsForSubmission)}`);

    try {
      //console.log(`Bearer ${auth.accessToken}`)
      const response = await axiosPrivate.post(url, approvedPaymentRequestsForSubmission, {
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
          'Authorization': `Bearer ${auth?.accessToken}`
          //'access-control-allow-origin' : '*'
        }
      })
        .then(response => {

          //console.log('inside response');
          //window.location.reload(false);
          dispatch({ type: 'resetpayments', payload: {} });
          // let tempRows = rows.map(item => item);
          // tempRows.map(item => item.isSelected = false)
          // setPaymentRequestRows(tempRows);
          // dispatch({ type: 'resetorderitems', payload: {}});
          // navigate('/paymentapprove', {replace:true});
          setApproved(approvedCount);

        })
        .catch(error => {
          console.log(error);
        });

    }
    catch (err) {

      console.log(err.response);

    }

  };

  const handleChangeRow = (row) => {
    let rowIndex = rows.findIndex(x => x.id == row.id)
    let tempRows = rows.map(item => item);
    tempRows[rowIndex] = row;
    setPaymentRequestRows(tempRows);
  };

  const handleClearSelection = () => {
    dispatch({ type: 'resetpayments', payload: {} });
    let tempRows = rows.map(item => item);
    tempRows.map(item => item.isSelected = false)
    setPaymentRequestRows(tempRows);
  };


  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Paper sx={{ width: '100%', mb: 5 }}>
          {/* <div>{approvedPaymentRequests.length}</div> */}
          <EnhancedTableToolbar
            grossAmount={approvedPaymentRequests.reduce((s, v) => s + rows.find((row) => row.id == v)?.grossAmount ?? 0, 0)}
            tds={approvedPaymentRequests.reduce((s, v) => s + rows.find((row) => row.id == v)?.tds ?? 0, 0)}
            advance={approvedPaymentRequests.reduce((s, v) => s + rows.find((row) => row.id == v)?.advance ?? 0, 0)}
            hold={approvedPaymentRequests.reduce((s, v) => s + rows.find((row) => row.id == v)?.hold ?? 0, 0)}
            netPayable={approvedPaymentRequests.reduce((s, v) => s + rows.find((row) => row.id == v)?.netPayable ?? 0, 0)}
            onClear={handleClearSelection}
          />

          <FilterDrawer setFilterSwitch={setFilterSwitch} 
            paymentStatusList={paymentStatusList} setPaymentStatus={setPaymentStatus} 
            locationList={locationList} setLocation={setLocation}
            setReqSDate={setReqStartDate} setReqEDate={setReqEndDate}
            setCheSDate={setCheckStartDate} setCheEDate={setCheckEndDate}
            setAuthSDate={setAuthStartDate} setAuthEDate={setAuthEndDate}
            setRejSDate={setRejStartDate} setRejEDate={setRejEndDate}
            />

          {/* <TextField id="deptFilter" label="Department" variant="standard" onChange={handleFilter} /> */}
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {visibleRows.map((row) => (
                  <Row key={row.id} row={row} isChecker={auth.roles.includes("Checker")} onValueChange={handleChangeRow} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRow.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        <FormControlLabel
          control={<Switch checked={dense} onChange={handleChangeDense} />}
          label="Dense padding"
        />
      </Box>
      <div style={{position: 'fixed',
          bottom: '2rem',
          right:  '7rem', // Adjust 240px to the width of the drawer
          transition: 'right 0.2s ease',
        }} className="d-grid gap-2 d-md-flex justify-content-md-end">
        <Fab variant="extended" disabled={approvedPaymentRequests.length == 0} color='success' className='btn-success' onClick={handleSubmit}>Approve All</Fab>
        <Fab variant="extended" disabled={approvedPaymentRequests.length == 0} color='error' className='btn-success' onClick={handleSubmit}>Reject All</Fab>
      </div>
      <br />
      {snackMessage &&
        <Snackbar open={snackMessage != ""} message={snackMessage}
          action={<IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => { setSnackMessage(""); }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>} />}
      <br />
    </>

  );
}


